export const selectRacksList = (state) => state.racks.racks;
export const selectRacksLoading = (state) => state.racks.loading;
export const selectRacksError = (state) => state.racks.error;
export const selectRacksSuccessMessage = (state) => state.racks.successMessage;
